import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    // Load user from localStorage on mount
    useEffect(() => {
        const storedUser = localStorage.getItem('unbox_user');
        if (storedUser) {
            try {
                setUser(JSON.parse(storedUser));
            } catch (e) {
                console.error('Failed to parse user', e);
                localStorage.removeItem('unbox_user');
            }
        }
        setIsLoading(false);
    }, []);

    const signup = (name, email, password) => {
        // Simulate signup (in production, this would be an API call)
        const users = JSON.parse(localStorage.getItem('unbox_users') || '[]');

        // Check if user already exists
        if (users.find(u => u.email === email)) {
            throw new Error('Un compte avec cet email existe déjà');
        }

        const newUser = {
            id: Date.now(),
            name,
            email,
            createdAt: new Date().toISOString()
        };

        users.push({ ...newUser, password }); // In production, hash password!
        localStorage.setItem('unbox_users', JSON.stringify(users));

        setUser(newUser);
        localStorage.setItem('unbox_user', JSON.stringify(newUser));

        return newUser;
    };

    const login = (email, password) => {
        // Simulate login (in production, this would be an API call)
        const users = JSON.parse(localStorage.getItem('unbox_users') || '[]');
        const foundUser = users.find(u => u.email === email && u.password === password);

        if (!foundUser) {
            throw new Error('Email ou mot de passe incorrect');
        }

        const { password: _, ...userWithoutPassword } = foundUser;
        setUser(userWithoutPassword);
        localStorage.setItem('unbox_user', JSON.stringify(userWithoutPassword));

        return userWithoutPassword;
    };

    const logout = () => {
        setUser(null);
        localStorage.removeItem('unbox_user');
    };

    const value = {
        user,
        isLoading,
        signup,
        login,
        logout,
        isAuthenticated: !!user
    };

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
